var _defs, _path, _g, _g2, _path2, _path3, _use, _use2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str1{stroke:#000;strokeWidth:.46;stroke-miterlimit:22.9256}.fil3{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c81010",
    d: "M0 0h600v162H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bird"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bird_outline",
    className: "str1",
    d: "M305.75 27.34c-19.08-7.89-30.76-9.34-43.81-9.47-18.9.13-27.92 8.25-45.94 9 7.14 7.69 33.02 9.57 43.93-.53 16.22 1.69 19.9 6.07 24.25 11.52-6.77-1.07-14.57-3.02-21.04 4.14-5.46 1.1-7.99 0-17.33 0-4.36 0-5.87 2.14-5.81 6 2.82-3.9 22.31-1.6 27.09 0 3.67 1.23 7.57 6.32 12.22 7.15 12.19 2.17 29.68-4.2 45.81-8.54L360 42h-23.93L366 36h-32.54c-.69-.79-2.34-1.81-3.66-2.68 8.37-5.39 15.77-15.19 17.66-19.92 15.09-.15 24.83-1.55 36.54-4.29-77.18-8.54-59.61.67-78.25 18.23z",
    fill: "#f8d000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye",
    d: "M270.06 39.89c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye_outline",
    d: "M270.06 39.89c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5z",
    fill: "none",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.15,
    strokeMiterlimit: 22.926
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 str1",
    d: "M290.13 38.29S283.86 42 279.7 42M325.12 46.61S330.85 42 336.07 42M233.82 24.6s4.66-2.44 6.86-3.09M253.13 21.12s7.39-3.19 15.62-3.03M273.11 21.9s9.69-1.63 18.64.36M284.25 24.24s8.04-1.35 15.75.83M292.52 26.69s8.19.11 12.26 1.69M216 26.87s11.49 3.14 20.83-1.35M217.46 28.23s14.92 3.68 21.74-3.15M222.46 30.81s11.24 3.62 20.08-5.72M232.9 33.08s9.08-2.6 12.52-7.95M240 33.23s6.09-4.22 8.28-7.98M318.46 28.47s2.38 2.99 11.34 4.85M320.04 27.06s3.85 3.85 11.87 4.79M321.98 25.25s3.91 3.36 12.42 4.61M323.91 23.32s5.98 3.99 12.79 4.45M326.27 20.8s4.19 3.91 12.5 4.88M328.03 18.79s4.91 4.22 12.63 4.8M329.76 16.69s3.01 3.48 12.94 4.39M331.52 14.42s3.35 3.68 12.78 4.48M332.89 12.55s5.9 4.45 12.73 4.36M334.06 10.85s7.8 4.68 12.45 4.53M335.48 8.69s6.2 3.86 11.98 4.71M308.84 30.38s2.5 1.89 4.84 1.81M310.28 28.98s2.17 1.85 5.15 1.84M312.03 27.26s2.46 2.3 5.41 1.88M313.69 25.6s2.94 2 5.57 1.94M315.53 23.71s2.18 1.89 5.63 2.07M317.17 21.63s2.56 2.27 5.82 2.35M318.9 20.13s2.48 1.59 5.99 1.89M320.47 18.38s3.35 1.18 6.42 1.47M322.28 16.24s2.31 1.62 6.41 1.52M323.91 14.1s2.74 1.82 6.26 1.86M325.11 12.07s3.68 2.06 6.85 1.6M326.45 9.64s2.33 2.55 6.67 2.46M327.39 8.54s4.18 2.35 7.01 1.75M329.16 7.21s3.17 1.93 6.07 1.85M332.38 6.24s5.65 2.88 13.29-.24M337.19 8.29s11.42 2.62 16.37-1.96M346.15 8.97s7.85.82 16.63-1.96M351.37 9.02s11.92 2.4 32.63.09M243.24 32.96s5.33-3.51 7.54-7.55M247.23 32.31s4.29-4.16 5.54-6.74M251.19 31.24s3.53-3.17 4.31-5.39M233.95 25.66s7.66-1.67 25.98.68M241.03 22.6s6.42-3.11 12.14-4.06M247.41 21.31s4.69-2.21 11.61-3.31M258.07 20.89s6.49-2.77 14.43-2.51M266.28 20.94s8.9-1.99 17.1-.87M290.11 25.29s6.79-.31 14.6 1.63M278.5 22.56s9.73-.52 16.4.71M338.67 8.57s3.36 2.91 12.72 4.76M343.95 9.04s5.26 2.99 13.56 4.03M349.47 9.08s7.38 3.21 15.18 3.41M357.64 9.78s7.52 1.81 16.84 1.32M262.41 20.78s5.1-2.1 14.14-1.93M296.04 28.42s3.06-.37 6.86 1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3 str1",
    d: "M284.18 37.86c2.11.33 4.12.58 5.95.43 7.16-3.91 12.05-7.58 15.62-10.95"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8d000",
    stroke: "#000",
    strokeWidth: 0.46,
    strokeMiterlimit: 22.926
  }, /*#__PURE__*/React.createElement("g", {
    id: "rays_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rays_2",
    transform: "rotate(-84.706 300 156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wavy",
    d: "M290.63 105.87A50 50 0 01300 66a50 50 0 009.37 39.87",
    transform: "rotate(13.4 300 156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "straight",
    d: "M290.63 105.87L300 63l9.37 42.87"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays_2",
    transform: "rotate(21.18 300 156)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays_2",
    transform: "rotate(42.35 300 156)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays_6",
    transform: "rotate(63.53 300 156)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays_6",
    transform: "rotate(127.06 300 156)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 156,
    r: 51
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#183070",
    d: "M0 162h600v138H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-36 168q30-12 60 0t60 0 60 0 60 0q30-12 63 0t66 0q33-12 63 0t60 0 60 0 60 0 60 0",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 24,
    id: "wave"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wave",
    y: 48
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wave",
    y: 96
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKi);
export default __webpack_public_path__ + "static/media/ki.f6baac854f2954122f6b916f95f9793f.svg";
export { ForwardRef as ReactComponent };